import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "../../auth/AuthProvider.js";
import { FullPageSpinner } from "../../auth/FullPageSpinner.js";
import { LandingPage } from "./LandingPage.js";
import { PublicLayout } from "./PublicLayout.js";

/**
 * `/` is the one path whose page depends on who is asking (spec §3): the
 * overview for a signed-in reseller, the wall for an applicant, the landing
 * page for everyone else.
 *
 * The loading branch is load-bearing, exactly as in `RequireAuth`: without
 * it a reload on a live session paints the marketing page for one frame
 * before the overview replaces it.
 *
 * `portal` is passed in rather than imported because the portal wrapper
 * (`Portal` in App.tsx) is private to the router and carries the shell's
 * query for the rail badges.
 */
export function HomeRoute({ portal }: { portal: ReactNode }): JSX.Element {
  const { user, applicant, status } = useAuth();
  if (status === "loading") return <FullPageSpinner />;
  if (user) return <>{portal}</>;
  if (applicant) return <Navigate to="/onboarding" replace />;
  return (
    <PublicLayout>
      <LandingPage />
    </PublicLayout>
  );
}
